import BaseService from '../BaseService';

class DoencasService extends BaseService {
    constructor() {
        super('/programas/doencas/');
    }
}

export default new DoencasService();
